import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
    private http = inject(HttpClient);

    private apiUrl = environment.apiUrl;

    cancelSubscriptionByProperty(propertyId: string): Observable<string> {
        return this.http.post<string>(
        `${this.apiUrl}/api/subscriptions/cancel-by-property`,
        null,  // no body needed
        {
            params: { propertyId },           // ?propertyId=...
            responseType: 'text' as 'json'    // since backend returns plain String
        }
        );
    }
}